import { SharedFooter } from '@atlassian/learning-components';
import useLoggedInUser from 'utils/useLoggedInUser';
import { communityAppUpdatesIsActive } from 'services/statsig/featureGates';

export const Footer = () => {
  const user = useLoggedInUser();
  const isLoggedIn = !!user;
  const email = user?.email || '';
  return (
    <SharedFooter
      isLoggedIn={isLoggedIn}
      email={email}
      showAppUpdates={communityAppUpdatesIsActive()}
    />
  );
};
